var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_4190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47275 14.4182C11.2806 14.4182 14.3674 11.3204 14.3674 7.49912C14.3674 3.67784 11.2806 0.580078 7.47275 0.580078C3.66496 0.580078 0.578125 3.67784 0.578125 7.49912C0.578125 11.3204 3.66496 14.4182 7.47275 14.4182Z",
    fill: "url(#paint0_linear_490_4190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47354 15C3.35296 15 0 11.6358 0 7.5C0 3.36483 3.35296 0 7.47354 0C11.5947 0 14.9471 3.36483 14.9471 7.5C14.9471 11.6358 11.5947 15 7.47354 15ZM7.47354 1.16188C3.9909 1.16188 1.15779 4.00503 1.15779 7.5C1.15779 10.995 3.9909 13.8381 7.47354 13.8381C10.9562 13.8381 13.7893 10.9944 13.7893 7.5C13.7893 4.00503 10.9562 1.16188 7.47354 1.16188Z",
    fill: "url(#paint1_linear_490_4190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57044 10.2588C6.41531 10.2588 6.26709 10.1966 6.15768 10.0851L4.02156 7.90652C3.79753 7.67762 3.80042 7.31047 4.02851 7.08507C4.2566 6.86083 4.62303 6.86314 4.84706 7.09204L6.55366 8.83253L10.0843 4.93034C10.3003 4.69275 10.6661 4.6759 10.9017 4.89085C11.1385 5.10639 11.1559 5.47354 10.9411 5.71172L6.99883 10.0688C6.89175 10.1873 6.74123 10.2558 6.58203 10.2593C6.57798 10.2588 6.5745 10.2588 6.57044 10.2588Z",
    fill: "#181A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_4190",
    x1: 9.7442,
    y1: 9.19685,
    x2: -2.94747,
    y2: 10.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ACCFB",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_490_4190",
    x1: 9.9357,
    y1: 9.34028,
    x2: -3.82162,
    y2: 10.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ACCFB",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_4190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9471,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/check-mark-icon.111d3848833762d7805a53114ca2893f.svg";
export { ForwardRef as ReactComponent };